import script from "./StudiesTableClinician.vue?vue&type=script&setup=true&lang=js"
export * from "./StudiesTableClinician.vue?vue&type=script&setup=true&lang=js"

import "./StudiesTableClinician.vue?vue&type=style&index=0&id=ec86e6f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec86e6f2"]])

export default __exports__